import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AlbtelecomContract, AlbtelecomContractSearchType} from "../models/SearchService/albtelecom-contract.model";

@Injectable({
    providedIn: "root"
})
export class AlbtelecomContractHttpClientService {
    private readonly base = environment.backendBaseUrl;
    private readonly endpoint = "/api/albtelecomcontract";
    private readonly fullPath = `${this.base}${this.endpoint}`;
    private readonly searchURL = this.fullPath + "/search";
    private readonly walletURL = this.fullPath + "/payment/web";
    private readonly CCURL = `${this.fullPath}/start-cc`;

    constructor(private http: HttpClient) {
    }

    /**
     * Search for Contracts
     * @param searchType Type of contract
     * @param invoiceNumber Mobile number
     */
    search(searchType: AlbtelecomContractSearchType, invoiceNumber: number) {
        const params = new HttpParams()
            .set("searchType", (searchType as number).toString())
            .append("number", invoiceNumber.toString());

        return this.http.get<AlbtelecomContract[]>(this.searchURL, {
            params
        });
    }

    /**
     * Pay Albtelecom Contract with EWallet
     * @param invoice AlbtelecomContract
     */
    payWallet(invoice: { invoice: AlbtelecomContract }) {
        return this.http.post<PaymentResponse>(this.walletURL, {
            invoice
        });
    }

    /**
     * Pay Albtelecom Contract with Credit Card
     * @param invoice AlbtelecomContract
     */
    payCC(invoice: { invoice: AlbtelecomContract }) {
        return this.http.post<any>(this.CCURL, {
            invoice
        });
    }
}
